const ModeEditIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={25}
    height={24}
    viewBox="0 0 25 24"
    fill="none"
    style={{ cursor: 'pointer' }}
    {...props}
  >
    <path
      d="M14.8039 9.02L15.7239 9.94L6.6639 19H5.7439V18.08L14.8039 9.02ZM18.4039 3C18.1539 3 17.8939 3.1 17.7039 3.29L15.8739 5.12L19.6239 8.87L21.4539 7.04C21.8439 6.65 21.8439 6.02 21.4539 5.63L19.1139 3.29C18.9139 3.09 18.6639 3 18.4039 3ZM14.8039 6.19L3.7439 17.25V21H7.4939L18.5539 9.94L14.8039 6.19Z"
      fill="white"
    />
  </svg>
);


export default ModeEditIcon;